import { isEqual } from "lodash"
import type { NextRouter } from "next/router"
import type { ReactNode } from "react"
import React from "react"

import type { Loading } from "@/lib/loading"
import { ReactPerformance } from "@/lib/react_performance"
import { RoutingContext } from "@/lib/routing/context"

type Props = {
  children: ReactNode
  loading: Loading.ContextData
  router: NextRouter
}

type State = {
  ready: boolean
  update: boolean
}

export class RoutingContainerComponent extends React.Component<Props, State> {
  public state: State = {
    ready: false,
    update: false,
  }

  public componentDidMount = () => {
    if (this.routerJustLoaded(this.props)) {
      this.onReady()
    }
  }

  public componentDidUpdate = () => {
    if (this.routerJustLoaded(this.props)) {
      this.onReady()
    }
  }

  public render = () => {
    return (
      <RoutingContext.Provider value={this.props.router}>
        {this.props.children}
      </RoutingContext.Provider>
    )
  }

  private onReady = () => {
    this.props.loading.update({
      routing: { loading: false },
    })
    this.setState({ ready: true })
  }

  private routerJustLoaded = ({ router }: Props) => {
    return !this.state.ready && router.isReady
  }

  public shouldComponentUpdate: ReactPerformance.Functions.ShouldComponentUpdate<
    Props,
    State
  > = ReactPerformance.curryShouldUpdateWithManagedState(
    this,
    ({ nextProps }) => {
      if (this.routerJustLoaded(nextProps)) {
        return { update: true }
      }

      if (!isEqual(this.props.router, nextProps.router)) {
        return { update: true }
      }

      if (this.props.children !== nextProps.children) {
        return { update: true }
      }
    }
  )
}
